/**
* Scroll to Fade Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Scroll to Fade Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {

    className: 'scroll-to-fade-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      const tl = gsap.timeline( {
        scrollTrigger: {
          trigger: '.scroll-to-fade-content',
          pin: '.scroll-to-fade-content',
          start: 'top top+=120px',
          end: '+=300',
        },
      } );

      gsap.utils.toArray( '.fading-text' ).forEach( ( text ) => {
        const tl = gsap.timeline( {

          scrollTrigger: {
            trigger: text,
            start: 'middle-=400 middle',
            end: '+=300',
            scrub: true,
            toggleActions: 'play reverse play reverse',
            toggleClass: 'absolute',
          },

        } );

        tl
            .to( text, {
              opacity: 0,
              duration: 1,
              y: '100vh',
              ease: 'none',
            }, 0 )
            .to( text, {
              opacity: 1,
              duration: 2,
              y: 0,
              ease: 'none',
            }, 0.5 )
            .to( text, {
              opacity: 0,
              duration: 1,
              delay: 2,
              y: '-50vh',
              ease: 'none',
            }, 1.0 );
      } );

      // foreach or array to handle text
      // largeTL.to() function or something similiar to fade in and out
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'scroll-to-fade-content', COMPONENT );
} )( app );
